module.exports = __webpack_public_path__ + "img/category-icon-gem.e8031c8a.png";